import EditRubricForm from 'components/Rubrics/EditRubricForm';
import { Button, Container, Stack, Text, styled } from 'shell/components';

const DesktopResult = ({
    result,
    setResult,
    rubricErrors,
    setRubricErrors,
    hasClickedSubmitRubric,
    validateTitle,
    validateCriteria,
    onClickEditSettings,
}) => {
    return (
        <CustomContainer device={'desktop'}>
            <RootStack alignItems={'flex-start'} spacing={5}>
                <Stack spacing={2}>
                    <Stack direction={'row'} spacing={4}>
                        <Text component={'h1'} variant={'h6'} weight={'semibold'}>
                            Review Rubric
                        </Text>
                        {/* <Button startIcon={<Icon kind={'video'} />} variant={'borderless'}>
                            Best Practices for Rubric Creation
                        </Button> */}
                    </Stack>
                    <Text>Please review and verify all AI-generated information for accuracy and completeness.</Text>
                </Stack>
                <CustomButton variant={'secondary'} onClick={onClickEditSettings}>
                    Edit Settings
                </CustomButton>
                <CustomEditRubricForm
                    form={result}
                    setForm={setResult}
                    errors={rubricErrors}
                    setErrors={setRubricErrors}
                    hasClickedSubmit={hasClickedSubmitRubric}
                    validateTitle={validateTitle}
                    validateCriteria={validateCriteria}
                />
            </RootStack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(({ theme }) => {
    return {
        background: theme.palette.ensightful.shades[0],
    };
});

const RootStack = styled(Stack)(() => {
    return {
        width: '100%',
    };
});

const CustomButton = styled(Button)(() => {
    return {
        zIndex: 1,
        alignSelf: 'flex-end',
    };
});

const CustomEditRubricForm = styled(EditRubricForm)(() => {
    return {
        position: 'relative',
        top: '-56px',
    };
});

export default DesktopResult;
